<template>
    <div v-show="visible">
        <el-dialog title="查看视频" :visible.sync="visible" :close-on-click-modal="false" :before-close="dialogClose"  width="500px">    
            <video
                id="myVideo"
                class="video-js vjs-big-play-centered vjs-fluid"
                style=""
                controls
                preload="auto"
                width="100%"
                height="100%"
                :src="videoDemoUrl"
                poster="">
            </video>

        </el-dialog> 
    </div>
</template>

<script>
    import http from '../../../../common/http';

    export default {
        data(){
            return{
                visible: false,
                videoDemoUrl: ""
            }
        },
        created:function () {
        },
        methods:{
             init(url){
                // console.log("视频播放地址："+url);
                this.visible = true;
                this.videoDemoUrl=url;
            },
            dialogClose(done){
                done();
                this.$reload;
            }
        },
        mixins: [http]
    }

</script>

<style scoped>
.video-js{
  width: 100%!important;
  height: 100%!important;
}
.video-js .vjs-big-play-button {
  font-size: 3em;
  line-height: 42px!important;
  height: 50px!important;
  width: 50px!important;
  display: block;
  position: absolute!important;
  left:50%!important;
  top:50%!important;
  margin-top:-25px!important;
  margin-left:-25px!important;
  padding: 0;
  cursor: pointer;
  opacity: 1;
  border: 0.06666em solid #fff;
  background-color: #2B333F;
  background-color: rgba(43, 51, 63, 0.7);
  border-radius: 50%!important;
  -webkit-transition: all 0.4s;
  transition: all 0.4s; 
}
.vjs-paused .vjs-big-play-button,
.vjs-paused.vjs-has-started .vjs-big-play-button {
    display: block!important;
}
.myVideo-dimensions {
  width: 100%!important;
  height: 100%!important;
  display: block!important;
}
.vjs-poster{
  background-size: 100% 100%!important;
}
</style>


// WEBPACK FOOTER //
// src/components/page/sys/user/Video.vue